import { useState, useEffect } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { useAccount } from '../Context/AccountProvider';
import { getCreatorDashboard } from '../services/CreatorService';
import ParagonCoinImage from '../images/pcoin.webp';
import ConquerPointsIcon from '../images/conquerpoints_icon.webp';
import VipIcon from '../images/vip_icon.webp';
import PaymentLogsIcon from '../images/payment_logs_icon.png';
import ChangePasswordIcon from '../images/changepassword_icon.png';

const STATIC_ACTION_CARDS = [
  { to: '/buycoins',        icon: ParagonCoinImage,   title: 'Paragon Coins',    desc: 'Purchase Paragon Coins to spend on premium game items.' },
  { to: '/changepassword',  icon: ChangePasswordIcon, title: 'Change Password',  desc: 'Secure your account by updating your password.' },
  { to: '/purchasehistory', icon: PaymentLogsIcon,    title: 'Purchase History', desc: 'View your full donation and purchase history.' },
];

// Temporary creator icon — replace with a real asset when available
function CreatorIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2l2.83 5.73 6.32.92-4.57 4.46 1.08 6.3L12 16.46l-5.66 2.95 1.08-6.3L2.85 8.65l6.32-.92L12 2z"
        fill="var(--gold)"
        stroke="var(--gold)"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ActionRow({ to, icon, title, desc, iconComponent }) {
  return (
    <LinkContainer exact to={to}>
      <div className="ma-nav-row">
        <div className="ma-nav-icon-wrap">
          {iconComponent
            ? iconComponent
            : <img src={icon} alt="" className="ma-nav-icon" />}
        </div>
        <div className="ma-nav-body">
          <span className="ma-nav-title">{title}</span>
          <span className="ma-nav-desc">{desc}</span>
        </div>
        <span className="ma-nav-chevron">›</span>
      </div>
    </LinkContainer>
  );
}

function MyAccount() {
  const { accountInfo } = useAccount();
  const { user } = accountInfo;
  const [isCreator, setIsCreator] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function checkCreator() {
      try {
        await getCreatorDashboard();
        if (!cancelled) setIsCreator(true);
      } catch {
        // no-access or network error — not a creator
      }
    }
    checkCreator();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="ma-page">
      <div className="ma-hero">
        <img src={`/images/avatar/${user.avatar}.webp`} alt="Character Avatar" className="ma-hero-avatar" />
        <div className="ma-hero-info">
          <h2 className="ma-hero-name">{user.name}</h2>
          <div className="ma-hero-stats">
            <div className="ma-hero-stat">
              <span className="ma-hero-stat-val">{Number(user.conquerPoints).toLocaleString()}</span>
              <span className="ma-hero-stat-label">
                <img src={ConquerPointsIcon} alt="" className="ma-hero-stat-icon" />
                Conquer Points
              </span>
            </div>
            <div className="ma-hero-divider" />
            <div className="ma-hero-stat">
              <span className="ma-hero-stat-val">{Number(user.donationPoints).toLocaleString()}</span>
              <span className="ma-hero-stat-label">
                <img src={ParagonCoinImage} alt="" className="ma-hero-stat-icon" />
                Paragon Coins
              </span>
            </div>
            <div className="ma-hero-divider" />
            <div className="ma-hero-stat">
              <span className="ma-hero-stat-val">{user.vip}</span>
              <span className="ma-hero-stat-label">
                <img src={VipIcon} alt="" className="ma-hero-stat-icon" />
                VIP Level
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="ma-nav-list">
        {STATIC_ACTION_CARDS.map(({ to, icon, title, desc }) => (
          <ActionRow key={to} to={to} icon={icon} title={title} desc={desc} />
        ))}
        {isCreator && (
          <ActionRow
            to="/creator"
            title="Creator Dashboard"
            desc="View your creator code stats, supporters, and pending payouts."
            iconComponent={<CreatorIcon className="ma-nav-icon" />}
          />
        )}
      </div>
    </div>
  );
}

export { MyAccount };
